import React from 'react'
import classnames from 'classnames'

import * as S from './styles'

export default function ButtonDefault(props) {
  return (
    <S.Button
      className={classnames(
        [props.upperCase ? 'upperCase' : ''],
        [props.bold ? 'bold' : ''],
        [props.size],
        [props.fullWidth ? 'fullWidth' : ''],
        [props.disabled ? 'disabled' : '']
      )}
      onClick={props.onClick}
      disabled={props.disabled}
      backgroundColor={props.backgroundColor}
      color={props.color}
    >
      {props.iconLeft && <S.IconLeft src={props.iconLeft} alt='' />}
      {props.text}
      {props.iconRight && <S.IconRight src={props.iconRight} alt='' />}
    </S.Button>
  )
}
